import { Routes as ReactRoutes, Route } from 'react-router-dom';
import Layout from '@/layout';
import ChatPage from '@/views/chat';
import Home from '@/views/home';
import SessionInitializer from '@/context/SessionInitializer';
import routePath from './route-path';

const Routes = () => {

    const routes = [
        {
            path: routePath.home,
            component: (
                <Layout>
                    <Home />
                </Layout>
            ),
            exact: true
        },
        {
            path: routePath.chat,
            component: (
                <Layout>
                    <ChatPage />
                </Layout>
            ),
            exact: true
        }
    ];

    return (
        <SessionInitializer>
            <ReactRoutes>
                {routes.map((route, index) => (
                    <Route key={index} path={route.path} element={<>{route.component}</>} />
                ))}
            </ReactRoutes>
        </SessionInitializer>
    );
};

export default Routes;
